import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import BrowserLanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend';

import { ConfigurationService } from './app/core/services/configuration';

const LANG_PARAM_NAME = 'lang';

i18n
    .use(Backend)
    .use(BrowserLanguageDetector)
    .use(initReactI18next)
    .init({
        load: 'currentOnly',
        fallbackLng: 'it',
        supportedLngs: [ 'it', 'en' ],
        defaultNS: 'CIPP',
        ns: 'CIPP',
        keySeparator: '_',
        detection: {
            lookupQuerystring: LANG_PARAM_NAME,
            lookupCookie: LANG_PARAM_NAME,
            lookupLocalStorage: LANG_PARAM_NAME,
            lookupSessionStorage: LANG_PARAM_NAME,
        },
        backend: {
            loadPath: async () => {
                const { i18n: i18nConfig } = await ConfigurationService.load();
                const { full, base } = i18nConfig.remote.path;
                return full 
                    ? full
                    : `${base}/dictionary/{{ns}}/{{lng}}/plain`;
            }
        }
    });